module.exports = __webpack_public_path__ + "img/ribbon-blue.75e717a2.png";